import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[toggleClassOnValue]',
  standalone: true
})
export class ToggleClassOnValueDirective implements AfterViewInit {
  @Input('toggleClassOnValue') customClass: string;

  constructor(private el: ElementRef, private control: NgControl) {}

  ngAfterViewInit(): void {
      const formFieldElement = this.el.nativeElement.closest('mat-form-field');
      if (formFieldElement) {
        if(this.control.value!=null){
          if (this.isValidValue(this.control.value)) {
                formFieldElement.classList.add(this.customClass || 'selected-value');
            } else {
                formFieldElement.classList.remove(this.customClass || 'selected-value');
            }
        }
        this.control.valueChanges?.subscribe(value => {
          if (this.isValidValue(value)) {
              formFieldElement.classList.add(this.customClass || 'selected-value');
          } else {
              formFieldElement.classList.remove(this.customClass || 'selected-value');
          }
        });
      }
  }

  private isValidValue(value: any): boolean {
      if (Array.isArray(value)) {
        return value.length > 0;
      } else if (typeof value === 'number' && !isNaN(value)) {
        return true;
      } else if (typeof value === 'string' && value.trim() !== '') {
        return true;
      } else if (typeof value === 'object' && value!=null && value!=undefined && Object.keys(value).length > 0) {
        return true;
      }else {
        return false;
      }
  }
}